module.exports = __webpack_public_path__ + "img/app-1.b7f0cc04.png";